// extracted by mini-css-extract-plugin
export default {"footingContainer":"footingContainer_footingContainer__HZcNY"};